import { render, staticRenderFns } from "./withdrawalHistory.vue?vue&type=template&id=600e3c60"
import script from "./withdrawalHistory.vue?vue&type=script&lang=js"
export * from "./withdrawalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports